// Resolves a gallery image URL.
// Uploaded images are stored as relative paths (e.g. "/api/gallery/media/...").
// External/pasted URLs (http/https/data) are returned unchanged.
export const resolveMediaUrl = (url) => {
  if (!url) return url;
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) {
    return url;
  }
  const API = process.env.REACT_APP_BACKEND_URL || '';
  return `${API}${url}`;
};
